import React, { FC } from 'react';
import Layout from '../Layout';
import SEO from '../Seo';

import LatestCompanies from '../../../../common/sections/LatestCompanies';
import Categories from '../../../../common/sections/Categories';

import meta from '../assets/meta';
import { ISite } from '../../../../types/site';

import { ICompany } from '../../../../types/company';

const Home: FC<{
    pageContext: { companies: ICompany[]; categories: string[]; siteData: ISite; hideArticlesNav: boolean };
}> = ({ pageContext: { companies, categories, siteData, hideArticlesNav } }) => {
    return (
        <Layout pageName="home" siteName={siteData.domain} hideArticlesNav={hideArticlesNav}>
            {companies?.length ? (
                <LatestCompanies cssPrefix={undefined as never} companies={companies} companiesBoxVersion={14} />
            ) : null}
            {categories?.length ? (
                <Categories cssPrefix={undefined as never} categories={categories} version={6} />
            ) : null}
        </Layout>
    );
};

export default Home;

export const Head: FC<{ pageContext: { siteData: ISite } }> = ({ pageContext: { siteData } }) => (
    <SEO siteData={siteData} {...meta.home} />
);
